import { Link } from 'react-router-dom'

import { Button, Card } from '../../../../components'
import { MasaDashboardPaths } from '../../../../config/routes'

export function BackofficeDashboard() {
    return (
        <div className='grid grid-cols-3 grid-rows-3 gap-4 p-8'>
            <Card className='w-full'>
                <div className='flex flex-row justify-between w-full'>
                    <h1>Users</h1>
                </div>
                <div>
                    <p>Pick and manage every user</p>
                </div>

                <div className='flex flex-row justify-end w-full mt-8'>
                    <Link to={MasaDashboardPaths.USERS}>
                        <Button className='rounded-lg hover:bg-gray6'>
                            Enter
                        </Button>
                    </Link>
                </div>
            </Card>
            <Card>
                <h1>Roles</h1>
                <p>Manage roles access</p>
            </Card>
            <Card>
                <h1>Providers</h1>
                <p>Enable providers for specific countries</p>
            </Card>
        </div>
    )
}
